import styled from 'styled-components';

import {colors, font} from 'theme';

export const Content = styled.div`
    padding: 0 2px 2px;
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const WarningCard = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    background: ${colors.warningOrangeSecondary};
    border: 1px solid ${colors.warningOrange};
    border-radius: 8px;
    padding: 12px;
    gap: 6px;
`;

export const WarningCardIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 100%;
`;

export const WarningCardContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    gap: 4px;
`;

export const WarningTitle = styled.div`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 4px;
`;

export const WarningDescription = styled.div`
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 12px;
    line-height: 16px;
`;

export const Footer = styled.div`
    border-top: 1px solid ${colors.border};
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 20px;
    margin-top: 20px;

    & > * {
        width: fit-content;
    }
`;
